import { Component, OnInit } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-deviation-source-view',
    templateUrl: './deviation-source-view.component.html',
    styleUrls: ['./deviation-source-view.component.css'],
})
export class DeviationSourceViewComponent implements OnInit {
    public deviationSourceKeyno: string = '';

    constructor(private state: StateService) {}

    public onDeviationSourceSave() {
        this.state.back();
    }

    public onDeviationSourceDelete() {
        this.state.back();
    }

    ngOnInit(): void {
        this.deviationSourceKeyno = this.state.getStateParams()['deviationsource_keyno'];
    }
}
